<template>
  <img :style="styleObject" :src="url"/>
</template>

<script>
import common from '@/mixins/common';

export default {
  mixins: [common],
  props: {
    icon: String,
    invertImgIcons: {type: Boolean, default: false},
    /**
     * functional color like "primary" with an additional space separated color modifier like "lighten-1" (1-4 allowed)
     * or "darken-1" (1-4 allowed)
     */
    iconColor: {
      type: String,
      default: '',
    },
    /**
     * CSS Color will preceed iconColor
     */
    color: {
      type: String,
    },
  },
  data() {
    return {
      styleObject: {
        color: this.color ? this.color + ' !important' : null,
        fontSize: this.fontSize,
        filter: this.invertImgIcons ? 'invert(1) opacity(90%)' : null,
        height: '24px',

      },
    };
  },
  computed: {
    url() {
      return this.assetUrl(this.icon);
    },
  },
};
</script>

